<template>
  <FilterTab>
    <template v-slot:title
    ><h6>Update Layout</h6></template
    >
    <template v-slot:body></template>
    <template v-slot:button1>
      <button class="edit_table_data font_detail" @click="goBack">
        <i class="fas fa-arrow-left"></i
        ><span class="mx-1 bold"> Go Back </span>
      </button>
    </template>
  </FilterTab>
  <div id="laser-print-preview" class="m-5"
       style="height: 374.4px; width: 796.8px; border: 1px solid black; position: relative">
    <div style=" height: 100%; display: flex;">
      <div
          v-for="(layer, index) in $store.getters.getTicketLayout.layers"
          :key="index"
          :style="{width: `${layer.width}px`, paddingTop: `${layer.topLayer}px`}"
          style="border-right: 1px solid black;"
      >
        <div v-for="(property, key) in layer.properties" :key="key" :class="property.name ? '' : 'gridClass'"
             :style="{marginLeft: `${property.left}px`, marginTop: `${property.top}px`, fontSize: `${property.fontSize}px`}">
          <div v-if="property.example1 && property.example2 && property.nameValue1 && property.nameValue2"
               :style="{fontWeight: property.fontWeight}">{{ property.example1 }} {{ property.separator }}
            {{ property.example2 }}
          </div>
          <div v-else>
            <span
                :style="[{width: `${property.nameWidth}px`}, property.name ? {display: 'inline-grid', textAlign: 'left', lineHeight: '12px', wordBreak: 'break-word' } : null]">{{
                property.name
              }}</span>
            <span v-if="property.name"> {{ property.separator + ' ' }} </span>
            <span
                :style="[{width: `${property.nameValueWidth}px`, fontWeight: property.fontWeight}, property.example1 ? {display: 'inline-grid', textAlign: 'left', lineHeight: '12px', wordBreak: 'break-word' } : null]"
            > {{ property.example1 }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row px-5">
    <div class="col-md-6">
      <input
          class="py-2  width-300  "
          type="button"
          value="Print Preview"
          @click="printTicket"
      />
    </div>
    <div class="col-md-6 text-end">
      <input
          class="py-2 mb-2 submit_button width-300  "
          type="submit"
          @click="updateTicketDesign"
      />
    </div>
  </div>
  <div class="p-5 overflow-auto" style="height: 500px">
    <div v-for="(layer, key) in properties" :key="key" class="mb-5">
      <div class="row">
        <div class="col-md-1">
          <h5>Layer-{{ key + 1 }}</h5>
        </div>
        <div class="col-md-1">
          <Input
              :id="'toppadding'"
              v-model="layer.topLayer"
              :label="'Top Margin'"
              :placeholder="'Enter top Margin'"
              :type="'number'"
          />
        </div>
        <div class="col-md-1">
          <Input
              :id="'layerwidth'"
              v-model="layer.width"
              :label="'Layer Width'"
              :placeholder="'Enter Layer Width'"
              :type="'number'"
          />
        </div>
      </div>
      <div v-for="(property, index) in layer.properties" :key="index" class="row">
        <div class="col">
          <Input
              :id="'nameproperty'"
              v-model="property.name"
              :label="'Name'"
              :placeholder="'Enter name'"
              :type="'text'"
          />
        </div>
        <div class="col">
          <Input
              :id="'example1'"
              v-model="property.example1"
              :label="'Example1'"
              :placeholder="'Enter example1'"
              :type="'text'"
          />
        </div>
        <div class="col">
          <Dropdown
              :id="'printType'"
              v-model="property.nameValue1"
              :defaultOption="'Select Name Value'"
              :defaultValue="''"
              :dropdown="nameValues"
              :hideLabel="'inactive'"
              :label="'Assign Value'"
          />

        </div>
        <div class="col">
          <Dropdown
              :id="'printType'"
              v-model="property.separator"
              :defaultOption="'Select separator'"
              :defaultValue="''"
              :dropdown="separators"
              :hideLabel="'inactive'"
              :label="'Separator'"
          />
        </div>
        <div class="col">
          <Input
              :id="'example2'"
              v-model="property.example2"
              :label="'Example2'"
              :placeholder="'Enter example2'"
              :type="'text'"
          />
        </div>
        <div class="col">
          <Dropdown
              :id="'printType'"
              v-model="property.nameValue2"
              :defaultOption="'Select Value2'"
              :defaultValue="''"
              :dropdown="nameValues"
              :hideLabel="'inactive'"
              :label="'Assign Value2'"
          />

        </div>
        <div class="col">
          <Input
              :id="'leftpadding'"
              v-model="property.nameWidth"
              :label="'Title Width'"
              :placeholder="'width'"
              :type="'number'"
          />
        </div>
        <div class="col">
          <Input
              :id="'leftpadding'"
              v-model="property.nameValueWidth"
              :label="'Title Value'"
              :placeholder="'Enter left padding'"
              :type="'number'"
          />
        </div>
        <div class="col">
          <Input
              :id="'leftpadding'"
              v-model="property.left"
              :label="'Left Margin'"
              :placeholder="'Enter left Margin'"
              :type="'number'"
          />
        </div>
        <div class="col">
          <Input
              :id="'topmargin'"
              v-model="property.top"
              :label="'Top Margin'"
              :placeholder="'Enter top Margin'"
              :type="'number'"
          />
        </div>
        <div class="col">
          <Dropdown
              :id="'fontWeight'"
              v-model="property.fontWeight"
              :defaultOption="''"
              :defaultValue="''"
              :dropdown="fontWeights"
              :hideLabel="'inactive'"
              :label="'Font-Weight'"
          />

        </div>

        <div class="col">
          <Input
              :id="'fontsize'"
              v-model="property.fontSize"
              :label="'Font Size'"
              :placeholder="'xx'"
              :type="'number'"
          />
        </div>
        <div class="col">
          <button v-if="layer.properties.length > 0 && index === 0" class="btn btn-danger mt-4" type="button"
                  @click="removeTicketProperty(key, index)">-
          </button>
          <button v-if="index === 0" class="btn btn-success mt-4" type="button" @click="addDesignProperty(key)">+
          </button>
          <button v-else class="btn btn-danger mt-4" type="button" @click="removeTicketProperty(key, index)">-</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {inject, onBeforeMount, ref} from "vue";
import {reactive} from "@vue/reactivity";
import store from "@/store";

export default {
  name: "TicketDesign",
  props: {
    layout: [String, Number],
  },
  setup(props, {emit}) {
    const layoutId = ref(props.layout)
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const propertyObject = reactive({
      name: "",
      example1: "",
      nameValue1: "",
      example2: "",
      nameValue2: "",
      left: 10,
      top: 0,
      fontWeight: 0,
      fontSize: 11,
      nameWidth: 66,
      nameValueWidth: 66,
      separator: ':',
    })
    let properties = ref([]);

    const nameValues = reactive({
      fromStoppage: "fromStoppage",
      toStoppage: "toStoppage",
      passengerName: "passengerName",
      passengerPhone: "passengerPhone",
      pnrCode: "pnrCode",
      seatNumbers: "seatNumbers",
      totalAmount: "totalAmount",
      discount: "discount",
      payable: "payable",
      tripDateTime: "tripDateTime",
      boardingTripDateTime: "boardingTripDateTime",
      boardingPlace: "boardingPlace",
      droppingPoint: "droppingPoint",
      coach: "coach",
      issuedBy: "issuedBy",
      referenced_by: "referenced_by",
      createdAt: "createdAt",
      route: "route",
      ticketDateTime: "ticketDateTime",
    })

    const separators = reactive({
      ":": "colon",
      "-": "dash",
    })

    const fontWeights = reactive({
      "400": "normal",
      "500": "bold",
      "700": "bolder",
    })

    const goBack = () => {
      emit("close");
    };

    const updateTicketDesign = () => {
      showLoader();
      store
          .dispatch("updateTicketLayout", {...store.getters.getTicketLayout, layers: properties.value})
          .then(() => {
            hideLoader();
            emit("close");
            emit("getAllTicketLayout")
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              updateTicketDesign();
            }
          });
    }

    const getTicketLayout = () => {
      showLoader();
      store
          .dispatch("getTicketLayout", {ticketLayoutId: layoutId.value})
          .then(() => {
            hideLoader();
            properties.value = store.getters.getTicketLayout.layers
            // initTicketValue()
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              getTicketLayout();
            }
          });
    };

    const addDesignProperty = (index) => {
      properties.value[index].properties.push({...propertyObject})
    }

    const removeTicketProperty = (key, index) => {
      properties.value[key].properties.splice(index, 1);
    }

    const printTicket = () => {
      let data = window.document.getElementById("laser-print-preview").innerHTML
      let divContents = data.replace(/border-right: 1px solid black;/g, 'border-right: 0px solid black;')
      var printWindow = window.open();
      var is_chrome = Boolean(window.chrome);
      printWindow.document.write('<html>')
      printWindow.document.write('<body>')
      printWindow.document.write('<style>')
      printWindow.document.write('@page { size: auto;  margin: 0mm; }')
      printWindow.document.write('</style>')
      printWindow.document.write(divContents)
      printWindow.document.write('</body></html>')
      printWindow.document.close()
      printWindow.focus()
      if (is_chrome) {
        printWindow.onload = function () {
          const cromeDelay = setTimeout(function () { // wait until all resources loaded
            printWindow.print();  // change window to winPrint
            printWindow.close();// change window to winPrint
            clearTimeout(cromeDelay)
          }, 200);
        };
      } else {
        printWindow.print()
        printWindow.close()
      }
    }

    onBeforeMount(() => {
      getTicketLayout()
    })


    return {
      addDesignProperty,
      properties,
      removeTicketProperty,
      nameValues,
      separators,
      goBack,
      updateTicketDesign,
      fontWeights,
      printTicket,
    };
  },
};
</script>

<style scoped>
.width-300 {
  width: 300px;
}
</style>
